import { Card, Text, Stack, Group, Badge, Progress, ThemeIcon } from '@mantine/core'
import { IconServer, IconCpu, IconDatabase } from '@tabler/icons-react'
import type { Node } from '@/types'
import { formatBytes } from '@/utils/format'

interface NodeStatusProps {
  nodes: Node[]
}

export function NodeStatus({ nodes }: NodeStatusProps) {
  return (
    <Card shadow="sm" p="lg" radius="md">
      <Text size="lg" fw={600} mb="md">
        Node Status
      </Text>

      <Stack gap="sm">
        {nodes.slice(0, 4).map((node) => {
          const cpuUsage = Math.random() * 100 // Mock data
          const memoryUsage = Math.random() * 100 // Mock data
          
          return (
            <Card key={node.ID} p="sm" withBorder>
              <Group justify="space-between" mb="xs">
                <Group gap="xs">
                  <ThemeIcon
                    size="sm"
                    variant="light"
                    color={node.Status.State === 'ready' ? 'green' : 'red'}
                  >
                    <IconServer size={16} />
                  </ThemeIcon>
                  <Text size="sm" fw={500}>
                    {node.Description.Hostname}
                  </Text>
                </Group>
                <Badge
                  size="sm"
                  color={node.Status.State === 'ready' ? 'green' : 'red'}
                  variant="dot"
                >
                  {node.Status.State}
                </Badge>
              </Group>

              <Stack gap="xs">
                <Group gap="xs">
                  <IconCpu size={14} />
                  <Text size="xs" c="dimmed">
                    CPU
                  </Text>
                  <Progress
                    value={cpuUsage}
                    size="xs"
                    flex={1}
                    color={cpuUsage > 80 ? 'red' : cpuUsage > 60 ? 'yellow' : 'green'}
                  />
                  <Text size="xs" c="dimmed">
                    {cpuUsage.toFixed(0)}%
                  </Text>
                </Group>

                <Group gap="xs">
                  <IconDatabase size={14} />
                  <Text size="xs" c="dimmed">
                    Memory
                  </Text>
                  <Progress
                    value={memoryUsage}
                    size="xs"
                    flex={1}
                    color={memoryUsage > 80 ? 'red' : memoryUsage > 60 ? 'yellow' : 'green'}
                  />
                  <Text size="xs" c="dimmed">
                    {memoryUsage.toFixed(0)}%
                  </Text>
                </Group>

                <Group gap="xs" justify="space-between">
                  <Text size="xs" c="dimmed">
                    {node.Spec.Role === 'manager' ? 'Manager' : 'Worker'}
                  </Text>
                  <Text size="xs" c="dimmed">
                    {formatBytes(node.Description.Resources.MemoryBytes)} RAM
                  </Text>
                </Group>
              </Stack>
            </Card>
          )
        })}
      </Stack>
    </Card>
  )
}